export default {
    mobile: 'مثل: ********۰۹۱۲',
    phone: 'مثل: ********۰۲۱',
}